/** Tags persisted on MapTODO place records until native `flags` is supported by the API. */
export const ARCHIVED_TAG = 'archived';
export const SECRET_TAG = 'secret';
/** Event house (theatre, hall). Hidden on public chips; switches the sheet to lead with shows. */
export const STAGE_TAG = 'stage';

/** Guest-visible name. Not the venue title. */
export const SECRET_LOCATION_TITLE = 'secret location';

/** Guest-visible blurb. Explains the lock and how to open it. */
export const SECRET_LOCATION_BLURB =
  'Secret locations are exclusive MapToBe spots. Sign in to unlock the name, address, and map pin.';

export function hasArchivedFlag(place) {
  if (!place) return false;
  if (place.flags?.archived === true) return true;
  return Array.isArray(place.tags) && place.tags.includes(ARCHIVED_TAG);
}

/** Add or remove the archived tag while preserving other tags. */
export function applyArchivedToTags(tags, isArchived) {
  const next = new Set(Array.isArray(tags) ? tags.filter(Boolean) : []);
  if (isArchived) {
    next.add(ARCHIVED_TAG);
  } else {
    next.delete(ARCHIVED_TAG);
  }
  return [...next];
}

export function hasSecretFlag(place) {
  if (!place) return false;
  if (place.flags?.secret === true) return true;
  return Array.isArray(place.tags) && place.tags.includes(SECRET_TAG);
}

/** Guest-facing alias: secret tag or `flags.secret`. */
export function isSecretPlace(place) {
  return hasSecretFlag(place);
}

export function hasStageFlag(place) {
  if (!place) return false;
  if (place.flags?.stage === true) return true;
  return Array.isArray(place.tags) && place.tags.includes(STAGE_TAG);
}

/** Event house: sheet leads with linked shows. */
export function isStagePlace(place) {
  return hasStageFlag(place);
}

/** Add or remove the secret tag while preserving other tags. */
export function applySecretToTags(tags, isSecret) {
  const next = new Set(Array.isArray(tags) ? tags.filter(Boolean) : []);
  if (isSecret) {
    next.add(SECRET_TAG);
  } else {
    next.delete(SECRET_TAG);
  }
  return [...next];
}
